import { render, staticRenderFns } from "./SetType.vue?vue&type=template&id=2015cfa0&scoped=true&"
import script from "./SetType.vue?vue&type=script&lang=js&"
export * from "./SetType.vue?vue&type=script&lang=js&"
import style0 from "./SetType.vue?vue&type=style&index=0&id=2015cfa0&scoped=true&lang=css&"
import style1 from "./SetType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015cfa0",
  null
  
)

export default component.exports